export const debounce = (func: any) => {
    let timer: any
    return (...args: any) => {
        const context = this;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            func.apply(context, args);
        }, 500);
    };
};
